import SEO from '../components/SEO/SEO'
import Layout from '../layout/Layout'

const NonDiscriminationPolicy = () => {
  return (
    <>
      <SEO />
      <Layout>
        <div className="relative">
          <div className="absolute inset-x-0 bottom-0 bg-gray-100 h-1/2" />
          <div className="mx-auto">
            <div className="relative">
              <div className="absolute inset-0">
                <img
                  className="object-cover w-full h-full"
                  src="typing-on-macbook.png"
                  alt="People working on laptop together"
                />
              </div>
              <div className="relative px-4 py-16 sm:px-6 sm:py-24 lg:py-32 lg:px-32">
                <h1 className="text-4xl tracking-tight font-extralight sm:text-5xl lg:text-6xl text-blue-dark">
                  Non-Discrimination Policy
                </h1>
              </div>
            </div>
          </div>
        </div>

        <section>
          <div className="max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8 text-grey">
            <h3 className="pb-8 text-xl">Notice of Non-Discrimination</h3>
            <p className="pb-8">
              Evry Health does not discriminate on the basis of race, color,
              nationality, disability, sex, spiritual beliefs, stereotypes, or
              identity. Employment is provided on an equal opportunity basis for
              all persons. Medical coverage is based on medical necessity
              without consideration given to identity and individual
              characteristics. Evry provides language services at no cost,
              including qualified interpreters, to people whose primary language
              is not English.
            </p>
            <p className="pb-8">
              If you believe Evry Health has failed to provide these services or
              discriminated in another way on the basis of race, color,
              nationality, disability, sex, spiritual beliefs, stereotypes, or
              identity, please contact Member Services at
              <a href="tel:18555793879" className="font-bold text-green">
                {' '}
                1-855-579-3879
              </a>
              .
            </p>
          </div>
        </section>
      </Layout>
    </>
  )
}

export default NonDiscriminationPolicy
